export default __webpack_public_path__ + "locales/de/Errors.json?hash=f063c62637110630c3f5942de364b508";